/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Sheet_Back_ToInputs */

const en_us2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Back to ${i?.name}`)
};

const pt_br2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voltar para ${i?.name}`)
};

const es_419_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volver a ${i?.name}`)
};

const pt_pt2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voltar a ${i?.name}`)
};

const fr_fr2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retour à ${i?.name}`)
};

const de_de2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zurück zu ${i?.name}`)
};

const it_it2_exercise_sheet_back_to = /** @type {(inputs: Exercise_Sheet_Back_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Torna a ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Back to {name}" |
*
* @param {Exercise_Sheet_Back_ToInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_back_to = /** @type {((inputs: Exercise_Sheet_Back_ToInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Back_ToInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_back_to(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_back_to(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_back_to(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_back_to(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_back_to(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_back_to(inputs)
	return en_us2_exercise_sheet_back_to(inputs)
});
export { exercise_sheet_back_to as "exercise-sheet.back_to" }